import { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormField from "../../../components/FormField/FormField";
import { connect } from "react-redux";
import { notification } from "../../../utils/utility";
import UpgradeToTeamModal from "./upgrade-to-team-modal";

const validation = Yup.object().shape({
  first_name: Yup.string().required("First Name is required."),
  last_name: Yup.string().required("Last Name is required."),
  email: Yup.string()
    .matches(
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
      "Please enter valid email"
    )
    .required("Email is required"),
});

let initialValues = {
  first_name: "",
  last_name: "",
  email: "",
};

class InviteUserModal extends Component {
  
  state = {
    isOpen: false,
    upgradeToTeamModalStatus: false
  };

  toggleUpgradeToTeamModal = () => {
    this.setState(prevState => ({
      upgradeToTeamModalStatus: !prevState.upgradeToTeamModalStatus,
    }));
  }

  /**
   * on toggle modal
   */
  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };


  inviteUserBtnHandler = () => {
    const { isOpen } = this.state;
    const { subscription } = this.props;
    console.log('sub', subscription);
    if (subscription.userPlan.plan_type === "individual") {
      this.toggleUpgradeToTeamModal();
    } else {
      this.setState({
        isOpen: !isOpen,
      });
    }
  }

  

  render() {
    const { isOpen, upgradeToTeamModalStatus } = this.state;
    const { onInviteStaff, subscription, getUserAndPlans } = this.props;
    const { userPlan } = subscription;

    return (
      <>
        {upgradeToTeamModalStatus && 
          <UpgradeToTeamModal  
            getUserAndPlans={getUserAndPlans}          
            toggle={this.toggleUpgradeToTeamModal}
            currentPlanPeriodType={userPlan.plan_period_type}
          />
        }
        <button className="btn btn-app w-auto" onClick={this.inviteUserBtnHandler}>
          <span className="mr-2">+</span> Invite User
        </button>
        <Modal isOpen={isOpen} toggle={this.toggle}>
          <ModalBody>
            <div className="">
              <div className="eventdetailsaddbox rd_modalvieew">
                <div className="box_content rd_modalboxcontent">
                  <div className="rd_inputselectheadermodalsetting">
                    <button
                      className="rd_colsebtn"
                      onClick={this.toggle}
                    ></button>
                  </div>
                  <h3 className="rd_modalheadertext rd_modalheadertextleft">
                    Invite new user
                  </h3>

                  {
                    (parseInt(userPlan?.plan_id)  === 6 && (
                      <div class="alert alert-info alert-dismissible fade show" role="alert">
                        <strong>Heads up!</strong> 
                        &nbsp; Adding a new user will increase your {userPlan?.plan_period_type === "monthly" ? "monthly " : "anuual "} 
                        plan by 
                        <strong> ${userPlan?.plan_period_type === "monthly" ? userPlan?.monthly_price : userPlan?.annual_price}</strong>.
                      </div>
                    ))
                  }
                  
                  <Formik
                    validationSchema={validation}
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={(data) => {
                      this.toggle();
                      onInviteStaff(data);
                    }}
                  >
                    {(formProps) => {
                      const {
                        values,
                        errors,
                        touched,
                        handleChange,
                        setFieldValue,
                      } = formProps;

                      return (
                        <Form>
                          <div className="rd_addnewuserfieth">
                            <label htmlFor="">First Name *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="first_name"
                                elementclasses="p-2"
                                placeholder="Enter First Name"
                                value={values.first_name}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "first_name", value },
                                  });
                                }}
                              />
                            </div>

                            <label htmlFor="">Last Name *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="last_name"
                                elementclasses="p-2"
                                placeholder="Enter Last Name"
                                value={values.last_name}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "last_name", value },
                                  });
                                }}
                              />
                            </div>

                            <label htmlFor="">Email *</label>
                            <div className="input-group">
                              <FormField
                                type="text"
                                name="email"
                                elementclasses="p-2"
                                placeholder="Enter Email"
                                value={values.email}
                                errors={errors}
                                touched={touched}
                                onChange={({ target }) => {
                                  const { value } = target;
                                  handleChange({
                                    target: { name: "email", value },
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="rd_cancelappbtnmodal">
                            <button
                              className="btn btn-danger"
                              onClick={this.toggle}
                            >
                              Back
                            </button>
                            <button type="submit" className="btn btn-app">
                              Send
                            </button>
                          </div>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  subscription: state.subscription,
});

export default connect(mapStateToProps, null)(InviteUserModal);


